import axios from '@/libs/http'

/**
 * 获取文章
 */
export const getArticle = (articleId) => {
    return axios.request({
        url: '/u/article/get',
        params: {
            articleId
        },
        method: 'GET'
    })
}

/**
 * 获取文章列表
 */
export const getArticleList = (type,pageNo,pageSize) => {
    return axios.request({
        url: '/u/article/list',
        params: {
            type,
            pageNo,
            pageSize
        },
        method: 'GET'
    })
}

